(function($){

	/**
	* Navigation mobile
	*/

	var menuOpen = $('.js-menu-open');
	var menuClose = $('.js-menu-close');
	var menuDrawer = $('.js-menu-drawer');
	var menuHeader = $('.js-menu-header');
	var menuContact = $('.js-menu-contact');

	// Trigger le drawer

	menuOpen.on('click', function(event) {
		event.preventDefault();
		$('body').addClass('stop-scroll drawer-is-visible');
		menuDrawer.addClass('is-visible');
	});

	menuClose.on('click', function(event) {
		event.preventDefault();
		$('body').removeClass('stop-scroll drawer-is-visible');
		menuDrawer.removeClass('is-visible');
	});

	// Affiche/cache au scroll

	var lastScrollTop = 0;

	$(window).on('scroll', function(event) {
		var currentScroll = $(this).scrollTop();
		// Cache le header passé un certain scroll
		currentScroll > menuHeader.outerHeight() ? menuHeader.addClass('is-hidden') : menuHeader.removeClass('is-hidden');

		if (currentScroll > lastScrollTop) {
			// Scroll up : cache le contact affiche le header
			menuContact.addClass('is-visible');
			menuHeader.removeClass('is-visible');
		} else {
			// Scroll down : cache le header affiche le contact
			menuContact.removeClass('is-visible');
			menuHeader.addClass('is-visible');
		}

		lastScrollTop = currentScroll;
	});

})(jQuery);
